export default __webpack_public_path__ + "images/Loggo.f31f6a11f1b71f1371588672c898e3c6.png";